import * as React from "react";

interface SurveyMonkeyWidgetProps {
    surveyMonkeyId: string;
    tenantUuid?: string;
    userUuid?: string;
}

export default function SurveyMonkeyWidget({ surveyMonkeyId, tenantUuid, userUuid }: SurveyMonkeyWidgetProps) {
    const buildSurveyUrl = () => {
        let url = `https://widget.surveymonkey.com/collect/website/js/${surveyMonkeyId}.js`;
        const params = new URLSearchParams();

        if (tenantUuid) {
            params.append("tenant_uuid", tenantUuid);
        }
        if (userUuid) {
            params.append("user_uuid", userUuid);
        }

        if (tenantUuid && userUuid && params.toString()) {
            const environment = process.env.NODE_ENV;
            if (environment) {
                params.append("environment", environment);
            }
            url += `?${params.toString()}`;
        }

        return url;
    };

    const surveyHtml = `
    <div>
      <script>
        (function(t,e,s,n){
          var o,a,c;
          t.SMCX=t.SMCX||[];
          if(!e.getElementById(n)){
            o=e.getElementsByTagName(s);
            a=o[o.length-1];
            c=e.createElement(s);
            c.type="text/javascript";
            c.async=!0;
            c.id=n;
            c.src="${buildSurveyUrl()}";
            a.parentNode.insertBefore(c,a);
          }
        })(window,document,"script","smcx-sdk");
      </script>
    </div>
  `;

    return (
        <>
            <iframe srcDoc={surveyHtml} width="100%" height="800px" />
        </>
    );
}
